/* eslint-disable no-unused-vars */
import { memo, useMemo, useEffect, useId } from 'react';
import { Typography, Stack } from '@mui/material';
import * as S from '../../ConversionTracking.styled';
import { CustomInput, CustomTooltip, CustomInputAutosize } from 'components';
import { Question } from 'assets/icons';
import { useComputed } from '@preact/signals-react';
import { useValidate } from './useValidate';

const titleText = {
  Deep_Link: 'Deep Link URL:',
  Tracking_Link: 'Click URL:',
  Impression_Link: 'Impression URL:',
  VTA_Link: 'Impression URL:',
};

const LinkSection_v1 = ({
  onChange,
  onBlurAction,
  name,
  cleanData$,
  tc_number$,
  click_tc_number,
  matchingDomains$,
  style,
  isSecondSection,
  trackingPartners,
}) => {
  const rowsNumber = useMemo(
    () => Math.ceil(cleanData$.value ? cleanData$.value.length / 120 + 2 : 3),
    [cleanData$.value],
  );

  const inputId = useId();
  const { handleValidation, error$, saveTc_number, isMandatoryField, currentIsMandatoryField } =
    useValidate(name, tc_number$, click_tc_number, cleanData$, isSecondSection);

  const change_Link = (e, matchingDomains) => {
    const link = e.target.value.replace('http://', 'https://');
    saveTc_number(link);
    handleValidation(link, matchingDomains, click_tc_number, isSecondSection);
    onChange(link);
  };

  useEffect(() => {
    if (cleanData$.value) {
      saveTc_number(cleanData$.value);
      handleValidation(
        cleanData$.value,
        matchingDomains$.value?.[name],
        click_tc_number,
        isSecondSection,
      );
    } else {
      handleValidation(
        cleanData$.value,
        matchingDomains$.value?.[name],
        click_tc_number,
        isSecondSection,
      );
    }
  }, [click_tc_number]);

  useEffect(() => {
    handleValidation(
      cleanData$.value,
      matchingDomains$.value?.[name],
      click_tc_number,
      isSecondSection,
    );
  }, [currentIsMandatoryField, cleanData$.value, click_tc_number]);

  return (
    <Stack sx={style}>
      <Stack direction='row' sx={{ justifyContent: 'space-between', marginBottom: '8px' }}>
        <Typography style={S.TitleLabels}>{titleText[name]}</Typography>
        {currentIsMandatoryField && trackingPartners ? (
          <Stack direction='row'>
            <Typography style={S.RequirementsLabels}>Supported Tracking Partners</Typography>
            <CustomTooltip
              style={{ marginLeft: '4px' }}
              content={<Question />}
              text={
                <p style={{ maxWidth: '180px' }}>
                  Supported Tracking Partners: {trackingPartners}
                  {/* Appsflyer, Adjust, Kochava, Appmetrica, Tenjin, Branch, Singular */}
                </p>
              }
            />
          </Stack>
        ) : (
          <Typography style={S.RequirementsLabels}>
            {currentIsMandatoryField ? 'Required' : 'Optional'}
          </Typography>
        )}
      </Stack>
      {useComputed(() => (
        <>
          {/* <CustomInput
            error={error$.value.errorValue}
            errorText={error$.value.errorText}
            onBlur={onBlurAction}
            onChange={(e) => change_Link(e, matchingDomains$.value?.[name])}
            multiline
            rows={rowsNumber < 9 ? rowsNumber : 9}
            id={`click_url_${inputId}`}
            name={`click_url_${inputId}`}
            value={cleanData$.value}
          /> */}
          <CustomInputAutosize
            value={cleanData$.value}
            id={`click_url_${inputId}`}
            name={`click_url_${inputId}`}
            onChange={(e) => change_Link(e, matchingDomains$.value?.[name])}
            deleteIcon={true}
            deleteIconOnClick={() => {
              change_Link(emptyStr, matchingDomains$.value?.[name]);
              onBlurAction();
            }}
            onBlur={onBlurAction}
            error={error$.value.errorValue}
            errorText={error$.value.errorText}
          />
        </>
      ))}
    </Stack>
  );
};

export default memo(LinkSection_v1);

const emptyStr = {
  target: {
    value: '',
  },
};
